import { render, staticRenderFns } from "./OrganizationPhoneTable.vue?vue&type=template&id=f017f0cc&"
import script from "./OrganizationPhoneTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationPhoneTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports